import { type MediaImageFragment } from '#graphql-operations'

export default function buildImageUrl (image: MediaImageFragment | null | undefined): string {
  return image?.image?.entity?.uri ? useImageUrl(image?.image?.entity?.uri, 'default_xxxl') : ''
}
